import { Capacitor } from '@capacitor/core';
import { useMemo } from 'react';

const platform = Capacitor.getPlatform();

const useNativeAppStyling = () => {
    const values = useMemo(() => {
        let statusBarOffset = "0px";
        let chatModalOffset = "0px";
        let chatButtonOffset = "0px";
        let toolbarOffset = 10;
        let bottomOffset = "0px";
        let bottomMapOffset = 0;

        if (platform === 'android') {
            statusBarOffset = "32px";
            chatModalOffset = "42px";
            chatButtonOffset = "6px";
            toolbarOffset = 42;
            bottomOffset = "26px";
            bottomMapOffset = 22;
        }

        if (platform === 'ios') {
            statusBarOffset = "env(safe-area-inset-top)";
            chatModalOffset = "env(safe-area-inset-top)";
            chatButtonOffset = "6px";
            toolbarOffset = 10;
            bottomOffset = "26px";
            bottomMapOffset = 16;
        }

        return {
            platform,
            statusBarOffset,
            chatModalOffset,
            chatButtonOffset,
            toolbarOffset,
            bottomOffset,
            bottomMapOffset
        };
    }, []);

    return values;
};

export default useNativeAppStyling;
